import { api } from './api.empty';

const adminSettingsType = 'Nexus.Sp.Models.Entities.AdminSettings';
const adminSettingsCacheDurationSeconds = 24 * 60 * 60;

export interface AdminSettingsDto {
  UseServiceLevelDefinitions?: boolean;
  UseCustomSubscriptions?: boolean;
}

export const isServiceLevelDefinitionsEnabled = (settings?: AdminSettingsDto) =>
  settings?.UseServiceLevelDefinitions ?? false;

export const isCustomSubscriptionsEnabled = (settings?: AdminSettingsDto) =>
  settings?.UseCustomSubscriptions ?? false;

const settingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    loadAdminSettings: build.query<AdminSettingsDto, void>({
      query: () => ({
        url: '/api/settings/load',
        method: 'POST',
        body: {
          SettingsType: adminSettingsType,
        },
      }),
      keepUnusedDataFor: adminSettingsCacheDurationSeconds,
    }),
  }),
  overrideExisting: false,
});

export const { useLoadAdminSettingsQuery } = settingsApi;
